/* eslint-disable react/jsx-no-target-blank */
import { getSettings, setSettings } from '@/utils';
import uid from 'easy-uid';
import PropTypes from 'prop-types';
import React from 'react';
import { Button } from '@/components/atom';
import { HookEntryContainer } from '@/components/molecule';
import { PresetsModalContainer } from '@/components/organism';
import styles from './options.module.less';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class Options extends React.PureComponent {
  static propTypes() {
    return {
      hookIds: PropTypes.arrayOf(PropTypes.number),
      selectedPresetId: PropTypes.string,
      presets: PropTypes.object,
      setPresets: PropTypes.func,
      addHook: PropTypes.func,
      alertSuccess: PropTypes.func
    };
  }
  constructor(props) {
    super(props);
    this.state = {
      modalOpened: false
    };
  }
  get isEditable() {
    const {
      presets,
      selectedPresetId
    } = this.props;
    return !!(presets && selectedPresetId && presets[selectedPresetId].editable);
  }
  async componentDidMount() {
    const {
      setPresets
    } = this.props;
    const {
      presets,
      selectedPresetId
    } = await getSettings();
    setPresets({
      presets,
      selectedPresetId
    });
  }
  render() {
    const {
      modalOpened
    } = this.state;
    const {
      hookIds
    } = this.props;
    return /*#__PURE__*/_jsxs("div", {
      className: styles.container,
      children: [/*#__PURE__*/_jsx(PresetsModalContainer, {
        onClose: e => this.onModalClose(e),
        opened: modalOpened
      }), /*#__PURE__*/_jsxs("form", {
        onSubmit: e => this.onSubmit(e),
        className: styles.form,
        children: [this._renderHeader(), /*#__PURE__*/_jsx("div", {
          className: styles.hooksWrapper,
          children: hookIds && hookIds.map(id => {
            return /*#__PURE__*/_jsx(HookEntryContainer, {
              editable: this.isEditable,
              id: id
            }, id);
          })
        }), this._renderFooter()]
      })]
    });
  }
  _renderHeader() {
    const {
      presets,
      selectedPresetId
    } = this.props;
    return /*#__PURE__*/_jsxs("div", {
      className: styles.header,
      children: [/*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx("h1", {
          children: "Hooks settings"
        }), /*#__PURE__*/_jsx("p", {
          children: "IMA.js developer tools works by wrapping certain methods in a proxy-like functions which sends information to the devtools prior to it's execution."
        }), /*#__PURE__*/_jsxs("p", {
          children: ["Since wrapping all functions in your application would produce too much clutter in the output, we provide default set of hooks which you can customize, turn on/off or completely remove to suit your needs.", ' ', /*#__PURE__*/_jsx("a", {
            href: "https://imajs.io/docs/devtools-introduction",
            target: "_blank",
            children: "For more information about devtools, visit imajs.io"
          }), "."]
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.actionsWrapper,
        children: [this.isEditable && /*#__PURE__*/_jsx(Button, {
          onClick: e => this.onAdd(e),
          color: "primary",
          children: "Add Hook"
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.loadPresetsWrapper,
          children: [/*#__PURE__*/_jsxs("p", {
            children: [/*#__PURE__*/_jsx("span", {
              className: styles.presetsLabel,
              children: "Current preset:"
            }), ' ', selectedPresetId && presets[selectedPresetId].name]
          }), /*#__PURE__*/_jsx(Button, {
            onClick: e => this.onLoadPreset(e),
            children: "Load or Create Preset"
          })]
        })]
      })]
    });
  }
  _renderFooter() {
    return /*#__PURE__*/_jsxs("div", {
      className: styles.footer,
      children: [!this.isEditable && /*#__PURE__*/_jsx("p", {
        className: styles.notEditable,
        children: "Current preset is not editable, please create new one by clicking on 'Load or Create Preset' button."
      }), /*#__PURE__*/_jsx(Button, {
        className: styles.saveBtn,
        color: "success",
        type: "submit",
        children: "Save Changes"
      })]
    });
  }
  onAdd(e) {
    e.preventDefault();
    const {
      addHook
    } = this.props;
    addHook(this._createHook());
  }
  onLoadPreset(e) {
    e.preventDefault();
    this.setState({
      modalOpened: true
    });
  }
  onModalClose() {
    this.setState({
      modalOpened: false
    });
  }
  onSubmit(e) {
    e.preventDefault();
    const {
      presets,
      selectedPresetId,
      alertSuccess
    } = this.props;
    const groupedData = {};
    const formData = new FormData(e.target);

    // Get changes from state
    for (let [key, value] of formData.entries()) {
      const [name, id] = key.split('__');
      if (!groupedData[id]) {
        groupedData[id] = {};
      }
      groupedData[id][name] = value;
    }
    const hooks = presets[selectedPresetId].hooks;

    // Merge with global redux state
    for (let id in hooks) {
      groupedData[id] = {
        ...hooks[id],
        ...groupedData[id],
        opened: false
      };
    }

    // Create new presets object with new data
    const newPresets = {
      ...presets
    };
    newPresets[selectedPresetId] = {
      ...newPresets[selectedPresetId],
      ...{
        hooks: groupedData
      }
    };

    // Save settings to storage
    setSettings({
      presets: newPresets,
      selectedPresetId
    });
    alertSuccess('Changes were saved.');
  }
  _createHook() {
    const id = uid();
    const displayId = id.substring(0, 6);
    return {
      id,
      enabled: false,
      opened: false,
      name: `Hook - ${displayId}`,
      description: `Description for hook - ${displayId}`,
      code: ''
    };
  }
}